import { createAction, createAsyncAction } from "typesafe-actions";

import * as AppType from "./types";

export const fetchCacheKeysAsync = createAsyncAction(
  "FETCH_CACHE_KEY_REQUEST",
  "FETCH_CACHE_KEY_SUCCESS",
  "FETCH_CACHE_KEY_FAILURE"
)<void, string[], void>();

export const updateAppInfo = createAction("UPDATE_APPLICATION_INFORMATION")<AppType.AppInfo>();

export const updateAuthToken = createAction("UPDATE_AUTH_TOKEN")<string>();

export const updateUserInfo = createAction("UPDATE_USER_INFO")<Partial<AppType.UserInfo>>();

export const updateUserInfoLoading = createAction("UPDATE_USER_INFO_LOADING")<LoadingState>();
